<div class="row">
     <div class="col-12">
          <div class="row justify-content-between align-items-center" id="page-title">
               <h1 class="progress-header col-12 col-lg-auto">
                    {{ 'Enroll in PSP_MAIN' | translator:'base'}}
               </h1>
          </div>
          <div class="row mb-2">
               <span class="col-12 col-lg-auto d-flex align-items-center small">
                    <i class="fas fa-triangle-exclamation me-2" aria-hidden="true"></i>
                    <span [innerHtml]="'Start_8-1' | translator:'base'">
                         Are you a <strong>driver</strong> looking for your own PSP record?
                    </span>
                    <a [routerLink]="'/driver/1'" (click)="scrollToTop()" name="Driver-record-request"
                         id="Driver-record-request" [title]="'Start_8-2' | translator:'base'" class="ms-1">
                         <span [innerHtml]="'Start_8-2' | translator:'base'">
                              Access your PSP record here.
                         </span>
                    </a>
               </span>
          </div>
          <div class="row">
               <div class="col-lg-8">
                    <div class="card shadow-sm rounded-0 border-0">
                         <div class="card-body">
                              <app-complete-bar [step]="19" [totalSteps]="19"></app-complete-bar>
                              <h2 [innerHtml]="'PayErrorHeading' | translator:'base'"
                                   *ngIf="!enrollmentService.EnrolledError">
                                   ERROR ADDING YOUR PAYMENT
                              </h2>
                              <h2 [innerHtml]="'Payment_0' | translator:'base'" *ngIf="enrollmentService.EnrolledError">
                                   ERROR SETTING UP YOUR ACCOUNT
                              </h2>
                              <div class="alert alert-danger mb-3" *ngIf="!enrollmentService.EnrolledError">
                                   <p class="mb-0" [innerHtml]="'PayErrorHeading_sub' | translator:'base'">
                                        An error occurred adding your payment. Please contact Customer Service.
                                   </p>
                              </div>
                              
                              <div class="alert alert-danger mb-3" *ngIf="enrollmentService.EnrolledError">
                                   <p class="mb-0" [innerHtml]="'Payment_0_1' | translator:'base'">
                                        An error occurred adding your payment. Please contact Customer Service.
                                   </p>
                              </div>
                              <p [innerHtml]="'PayErrorHeading_3' | translator:'base'" *ngIf="!enrollmentService.EnrolledError">
                                   <b>Your enrollment is complete but you will not be able to make driver record
                                        requests until payment has
                                        been set up</b>
                              </p>
                              <p [innerHtml]="'ContactUsHelpText' | translator:'base'">
                                   The PSP customer service team is available Monday through Thursday from 8 AM to 6 PM ET, and on Friday from 8 AM to 5 PM
                                   ET. To chat with an online representative, click the "LIVE HELP" button in the top-right corner of this page. You can
                                   also email us at <a href="mailto:PSPhelp@tylertech.com\"
                                      title="PSPhelp@tylertech.com">PSPhelp&#64;tylertech.com</a> or call us toll-free at <a href="tel:1-877-642-9499"
                                      title="1-877-642-9499">1-877-642-9499</a>.
                              </p>
                              <app-contact-form [contactFormInfo]="contactFormInfo" class="form-wizard"></app-contact-form>
                              
                         </div>
                    </div>
               </div>
               <app-progress-wizard [wizardObj]="wizardObj" [activeStep]="8"
                    [pageType]="enrollmentService.newCustomer!.customerType || '-'"
                    class="col-lg-4 sidebar d-none d-lg-block"></app-progress-wizard>
          </div>
     </div>
</div>